<template>
  <div class="layout overflow-y-auto bg-primary-white sm:bg-[transparent]">
    <div class="bg-icon__wrapper">
      <svg
        class="bg-icon"
        width="699px"
        height="699px"
        viewBox="0 0 699 699"
        fill="none"
      >
        <path
          d="M698.383 241.704H457.266V0.587463L241.705 0.587463V241.704H0.587402L0.587402 457.267H241.705V698.384H457.266L457.266 457.267L698.383 457.267V241.704Z"
          fill="#303AB2"
          fill-opacity="0.05"
        />
      </svg>
    </div>
    <div class="layout__navbar">
      <img
        class="w-[161px] h-9 cursor-pointer"
        src="@/assets/images/logo-main.svg"
        alt="logo"
        @click="goToSignIn"
      />
      <Button
        class="primary large w-[150px] sm:block hidden"
        :class="{ 'newPassword-layout': isNewPasswordPage }"
        @click="goToSignIn"
        >Sign in</Button
      >
    </div>
    <router-link
      to="/"
      class="auth-link"
      :class="{ 'newPassword-layout': isNewPasswordPage }"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16.75"
        height="14"
        viewBox="0 0 20 16"
        fill="none"
      >
        <path
          d="M8.75 15L1.75 8L8.75 1"
          stroke="#2B5DE5"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M1.75 8L18.5 8"
          stroke="#2B5DE5"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
      <p class="text-primary-base text-lg">Go Back</p>
    </router-link>
    <div class="content flex-grow">
      <slot />
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button";
export default {
  name: "AuthLayout",
  props: {
    isLogin: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Button,
  },
  data() {
    return {
      isNewPasswordPage: false,
    };
  },
  methods: {
    goToSignIn() {
      this.$router.push({ path: "/" });
    },
  },
  watch: {
    "$route.name"(newValue) {
      this.isNewPasswordPage = newValue === "createNewPassword";
    },
  },
  created() {
    this.isNewPasswordPage = this.$route.name === "createNewPassword";
  },
};
</script>

<style lang="css" scoped>
.layout {
  @apply px-6 md:px-12 pt-[29px] sm:pt-[46px] pb-[107px] sm:pb-[74px] min-h-screen h-full relative flex flex-col !bg-greyscale-65;
}

.layout .layout__navbar {
  @apply flex w-full flex-none justify-between items-center pb-[37px] sm:pb-0;
}

.content {
  @apply flex-1;
}

.auth-link {
  @apply flex flex-row items-center gap-2 left-12 absolute top-36 invisible lg:visible;
}

.newPassword-layout {
  @apply !hidden;
}
.bg-icon path {
  @apply dark:!fill-[#303AB2];
}
.dark .bg-icon path {
  fill-opacity: 0.05 !important;
}
</style>
